<kodit-dropdown
  [options]="items"
  [formCtrlId]="formCtrlId"
  [formCtrl]="korisnickaGrupaCtrl"
  ctrlPlaceholder="Odaberite korisničku grupu"
></kodit-dropdown>
